import {
	createSerpMonitoringConfig,
	updateSerpMonitoringConfig,
} from '@/API/repositories/serpMonitoring';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import { useRequestsContext } from '@/common/hooks/requestHook';
import { useMessageQueueContext } from '@/common/hooks/useMessageQueue';
import { filterProductOptionsByMarket } from '@/common/functions/filterProductOptionsByMarket';
import { useFormik } from 'formik';
import { useState } from 'react';

const useSerpMonitoringForm = ({ setShow, selectedConfig, reload }) => {
	const { makeRequest, hasUnfilledRequest } = useRequestsContext();
	const {
		options: { productsOptions, marketsOptions },
		commonData: { queues },
	} = useCommonDataContext();
	const { addMessage } = useMessageQueueContext();
	const [keyWords, setKeyWords] = useState(selectedConfig?.key_words || []);
	const [gradeKeyWords, setGradeKeyWords] = useState(
		selectedConfig?.grade_key_words || [],
	);
	const [blacklistWords, setBlacklistWords] = useState(
		selectedConfig?.blacklist_words || [],
	);
	const [platformLinks, setPlatformLinks] = useState(
		selectedConfig?.platform_links || [],
	);

	const isLoading =
		hasUnfilledRequest(createSerpMonitoringConfig) ||
		hasUnfilledRequest(updateSerpMonitoringConfig);

	const handleSubmit = async (values) => {
		const payload = {
			product: values.product?.value,
			market: values.market?.value,
			key_words: keyWords,
			grade_key_words: gradeKeyWords,
			blacklist_words: blacklistWords,
			platform_links: platformLinks,
			google_drive_id: values.googleDriveId,
			search_data: {
				language: values.language,
				gl: values.gl,
				lr: values.lr,
				location: values.location,
				google_domain: values.googleDomain,
			},
		};

		const requestFn = selectedConfig
			? updateSerpMonitoringConfig
			: createSerpMonitoringConfig;

		const response = await makeRequest(
			requestFn.bind(null, payload, selectedConfig?._id),
		);

		if (!response?.data) {
			return addMessage('Check your data and try again', 'error');
		}

		addMessage('SERP config saved', 'success');
		setShow(false);
		reload();
	};



	const formik = useFormik({
		initialValues: {
			product: productsOptions.find(
				(option) => option.value === selectedConfig?.product?._id,
			),
			market: marketsOptions.find(
				(option) => option.value === selectedConfig?.market?._id,
			),
			googleDriveId: selectedConfig?.google_drive_id || '',
			language: selectedConfig?.search_data?.language || '',
			gl: selectedConfig?.search_data?.gl || '',
			lr: selectedConfig?.search_data?.lr || '',
			location: selectedConfig?.search_data?.location || '',
			googleDomain: selectedConfig?.search_data?.google_domain || '',
		},
		onSubmit: (values) => handleSubmit(values),
	});

	const productOptions = filterProductOptionsByMarket(
		queues,
		productsOptions,
		formik.values.market?.value,
	);

	const handleMarketChange = (market) => {
		if (market?.value === formik.values.market?.value) {
			return;
		}

		formik.setFieldValue('market', market);
		formik.setFieldValue('product', null);
	};

	return {
		formik,
		productOptions,
		marketsOptions,
		keyWords,
		setKeyWords,
		gradeKeyWords,
		setGradeKeyWords,
		blacklistWords,
		setBlacklistWords,
		platformLinks,
		setPlatformLinks,
		isLoading,
		handleMarketChange,
	};
};

export default useSerpMonitoringForm;
